import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
import Image from "../../../../../base/multimedia/image/index.js";
import { Title } from "../../../../../base/text/title/index.js";
import * as SS from "../../styled.js";
import * as S from "./styled.js";
const MobileCarouselHeader = ({ props , className , ...rest })=>{
    const { items =[] , config , title , variant  } = props ?? {};
    const { hasNavigation , hasPagination , image  } = config ?? {};
    const { resize  } = image ?? {};
    const { width , height  } = resize ?? {};
    return /*#__PURE__*/ _jsxs(SS.CarouselHeaderBlock, {
        "data-testid": "CarouselHeaderBlock",
        className: className,
        ...rest,
        children: [
            title && /*#__PURE__*/ _jsx(Title, {
                ...title
            }),
            /*#__PURE__*/ _jsx(S.CarouselHeaderMobileSlider, {
                type: "fade",
                autoplay: true,
                rewind: true,
                pauseOnHover: false,
                pauseOnFocus: false,
                arrows: hasNavigation,
                pagination: hasPagination,
                $variant: variant,
                children: Children.toArray(items.map((item, index)=>/*#__PURE__*/ _jsx(Image, {
                        resize,
                        width,
                        height,
                        isLazy: index > 0 ? true : false,
                        ...item,
                        "data-testid": "CarouselHeaderImage"
                    })))
            })
        ]
    });
};
export default MobileCarouselHeader;

//# sourceMappingURL=index.js.map